import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import VendorsPage from "./pages/VendorsPage";
import ClientsPage from "./pages/ClientsPage";
import EmployeesPage from "./pages/EmployeesPage";
import LoadSlipsPage from "./pages/LoadSlipsPage";
import OrdersPage from "./pages/OrdersPage";
import AttendancePage from "./pages/AttendancePage";
import LeaveBalancePage from "./pages/LeaveBalancePage";
import OfferLettersPage from "./pages/OfferLettersPage";
import TruckMasterPage from "./pages/TruckMasterPage";
import DriversPage from "./pages/DriversPage";
import GPSTrackingPage from "./pages/GPSTrackingPage";
import SIMFastagTrackingPage from "./pages/SIMFastagTrackingPage";
import PANVerificationPage from "./pages/PANVerificationPage";
import VehicleRCVerificationPage from "./pages/VehicleRCVerificationPage";
import InvoicesPage from "./pages/InvoicesPage";
import UserManagementPage from "./pages/UserManagementPage";
import CompanySettingsPage from "./pages/CompanySettingsPage";
import AccountingPage from "./pages/AccountingPage";
import CompaniesPage from "./pages/CompaniesPage";
import OnlineBuiltyPage from "./pages/OnlineBuiltyPage";
import APIManagementPage from "./pages/APIManagementPage";
import ReceivablesAgingPage from "./pages/ReceivablesAgingPage";
import DashboardLayout from "./components/DashboardLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-primary animate-pulse font-heading text-2xl">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="load-slips" element={<LoadSlipsPage />} />
            <Route path="online-builty" element={<OnlineBuiltyPage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="invoices/aging" element={<ReceivablesAgingPage />} />
            <Route path="trucks" element={<TruckMasterPage />} />
            <Route path="drivers" element={<DriversPage />} />
            <Route path="gps-tracking" element={<GPSTrackingPage />} />
            <Route path="sim-fastag-tracking" element={<SIMFastagTrackingPage />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="employees" element={<EmployeesPage />} />
            <Route path="attendance" element={<AttendancePage />} />
            <Route path="leave-balance" element={<LeaveBalancePage />} />
            <Route path="offer-letters" element={<OfferLettersPage />} />
            <Route path="pan-verification" element={<PANVerificationPage />} />
            <Route path="vehicle-rc-verification" element={<VehicleRCVerificationPage />} />
            <Route path="accounting" element={<AccountingPage />} />
            <Route path="user-management" element={<UserManagementPage />} />
            <Route path="company-settings" element={<CompanySettingsPage />} />
            <Route path="companies" element={<CompaniesPage />} />
            <Route path="api-platform" element={<APIManagementPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
